import React from 'react'
import Drawer from '@mui/material/Drawer'
import Box from '@mui/material/Box'
import { drawerWidth } from '.'
import { useImpersonation } from '../../context/impersonationContext'
import DesktopListSideBar from './desktopListSideBar'

const DesktopSidebar: React.FC = () => {
  const { isImpersonating } = useImpersonation()
  
  return (
    <Drawer
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          boxSizing: 'border-box',
          backgroundColor: 'primary.background',
          pl: '44px',
          pr: '18px',
          borderRight: 'none',
          zIndex: 1300,
          top: isImpersonating ? '60px' : '0px',
          height: isImpersonating ? 'calc(100vh - 60px)' : '100vh',
          transition: 'none !important',
        },
        display: 'block',
      }}
      variant="persistent"
      anchor='left'
      open={true}
    >
      <Box
        component='img'
        src='/logo.svg'
        sx={{ mb: '66px', width: '194px', height: '36px', mt: '67px' }}
      />
      <DesktopListSideBar />
    </Drawer>
  );
};

export default DesktopSidebar;
